module.exports = __webpack_public_path__ + "images/header-harmonie-muenchen-galerie-198a2e96ad2c2e98a7c45aaeac47753b.jpg";